<template>
  <v-dialog
    v-model="showDialog"
    max-width="290"
  >
    <template #activator="{ on }">
      <v-btn
        id="doctor_finish"
        class="ml-2 mt-2"
        color="primary"
        v-on="on"
      >
        Finish Screener / New Patient
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">
        Survey Complete
      </v-card-title>

      <v-card-text class="text-left subtitle-2">
        Thank you for completing the survey.<br>
        Please return this device to our staff or
        let them know you have completed the survey.
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="error"
          text
          @click="showDialog = false"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="resetAnswers"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import { resetAnswers } from '@/use/screener'

export default {
  setup: () => {
    const showDialog = ref(false)

    return {
      showDialog,
      resetAnswers
    }
  }
}
</script>
